




































import mixins from 'vue-typed-mixins';
import { Page, Section } from '@/utils/SurveyUtils';
import SectionForm from '../SectionForm.vue';
import PageForm from '../PageForm.vue';
import cloneDeep from 'lodash.clonedeep';
export default mixins().extend({
  components: {
    SectionForm,
    PageForm,
  },

  props: {
    value: {
      type: Object as () => {
        mode?: 'create' | 'edit';
        pristine?: Partial<Page | Section>;
        parent?: Partial<Page | Section>;
      },
    },
  },

  computed: {
    visible(): boolean {
      return !!this.value.mode;
    },

    nodeType(): 'section' | 'page' | undefined {
      if (this.value.mode === 'create') {
        if (!this.value.parent) {
          return 'section'; // if pristine (parent) is undefined, it must be a section type
        } else {
          const parent: Section = this.value.parent as Section; // only sections have children and can be a parent, this is just for typing
          if (parent.children?.length > 0) {
            return parent.children[0]?.type; // all children must have same type, so just use the first one
          } else {
            return undefined; // no children so type must be picked from dropdown
          }
        }
      } else if (this.value.mode === 'edit') {
        return this.internal?.type;
      } else {
        return undefined;
      }
    },
  },

  data(): {
    internal?: Partial<Page | Section>;
  } {
    return {
      internal: {},
    };
  },

  methods: {
    submit() {
      this.$emit('submit', this.internal);
    },

    cancel() {
      this.value.mode = undefined;
      this.value.pristine = undefined;
      this.value.parent = undefined;
    },

    generateInternal(type?: 'section' | 'page') {
      let item;
      if (type === 'section') {
        item = {
          type: type,
          key: undefined,
          title: this.$languageobj(),
          name: this.$languageobj(),
          children: [],
          level: 'org',
        } as Partial<Section>;
      } else if (type === 'page') {
        item = {
          type: type,
          shortname: this.$languageobj(),
          longname: this.$languageobj(),
          helptext: this.$languageobj(),
          questions: [],
        } as Partial<Page>;
      } else {
        item = {};
      }

      this.internal = {
        ...item,
        ...cloneDeep(this.value.pristine),
      };
    },
  },

  watch: {
    value(value) {
      this.generateInternal(this.nodeType); // when value changes, use nodeType which is computed from passed values
    },

    'internal.type'(type) {
      this.generateInternal(type); // when the type dropdown changes, use it to generate the internal object
    },
  },
});
